import MultipleChoice from '../view/multiple-choice';
import SingleChoice from '../view/single-choice.jsx';
import AbstractPage from '../view/abstract-page';
import Comment from '../view/comment.jsx';

export const SELECT_VIEW = [
  [['type', 'simple-question'], ['isMultiple', true], MultipleChoice],
  [['type', 'simple-question'], ['isMultiple', false], SingleChoice],
  [['type', 'simple-question'], SingleChoice],
  [['type', 'comment'], Comment],
  [AbstractPage]
];



// WEBPACK FOOTER //
// ./components/page/settings/constants.js